import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { ShoppingBag, User, LogOut, LayoutDashboard } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";

export const Nav = () => {
  const { count, setOpen } = useCart();
  const { user, logout } = useAuth();
  const [scrolled, setScrolled] = useState(false);
  const loc = useLocation();
  const nav = useNavigate();

  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", h);
    return () => window.removeEventListener("scroll", h);
  }, []);

  return (
    <header
      data-testid="main-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${scrolled ? "bg-[#080808]/80 backdrop-blur-xl border-b border-[#222]" : "bg-transparent"}`}
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <nav className="hidden md:flex items-center gap-8 flex-1">
          <Link to="/shop?category=insects" data-testid="nav-insects" className="overline link-underline">Insects</Link>
          <Link to="/shop?category=rodents" data-testid="nav-rodents" className="overline link-underline">Rodents</Link>
          <Link to="/shop" data-testid="nav-shop" className="overline link-underline">All Feeders</Link>
        </nav>

        <Link to="/" data-testid="nav-logo" className="flex-1 md:flex-none text-center flex items-center justify-center gap-3">
          <img src="/logo.jpeg" alt="Combs Crickets & Critters" className="h-11 w-11 rounded-full object-cover" />
          <span className="font-display text-xl md:text-2xl tracking-tight text-[#F4F1EC] hidden sm:inline">Combs<span className="text-[#C7F000]">.</span></span>
        </Link>

        <div className="flex items-center gap-5 flex-1 justify-end">
          {user && user.role === "admin" && (
            <Link to="/admin" data-testid="nav-admin" className="hidden md:flex items-center gap-2 overline hover:text-[#C7F000] transition-colors">
              <LayoutDashboard size={15} /> Admin
            </Link>
          )}
          {user ? (
            <>
              <Link to="/orders" data-testid="nav-orders" className="hidden md:block overline hover:text-[#C7F000] transition-colors">Orders</Link>
              <button data-testid="nav-logout" onClick={async () => { await logout(); nav("/"); }} className="text-[#8A8782] hover:text-[#F4F1EC] transition-colors"><LogOut size={18} /></button>
            </>
          ) : (
            <Link to="/auth" data-testid="nav-auth" state={{ from: loc.pathname }} className="text-[#8A8782] hover:text-[#F4F1EC] transition-colors"><User size={18} /></Link>
          )}
          <button data-testid="cart-toggle" onClick={() => setOpen(true)} className="relative text-[#F4F1EC] hover:text-[#C7F000] transition-colors">
            <ShoppingBag size={19} />
            {count > 0 && (
              <span data-testid="cart-count" className="absolute -top-2 -right-2 bg-[#C7F000] text-black text-[10px] w-4 h-4 flex items-center justify-center rounded-full font-medium">{count}</span>
            )}
          </button>
        </div>
      </div>
    </header>
  );
};
